const normalizeValue = (value) => {
  if (value === undefined || value === null) return "";
  return String(value).trim();
};

const pushIfValid = (filters, label, value) => {
  const normalized = normalizeValue(value);
  if (!normalized) return;
  filters.push(`${label}:${normalized}`);
};

export const buildExportFilters = (state) => {
  if (!state) return [];
  const filters = [];

  // Grouping scope
  pushIfValid(filters, "group", state.selectedGroupType);

  // Time range
  pushIfValid(filters, "time", state.chosenTime);

  // District/school/class filters (avoid student identifiers)
  if (state.chosenDistrict && state.chosenDistrict !== "All Districts") {
    pushIfValid(filters, "district", state.chosenDistrict);
  }
  if (state.chosenSchool && state.chosenSchool !== "All Schools") {
    pushIfValid(filters, "school", state.chosenSchool);
  }
  if (state.chosenClass && state.chosenClass !== "All Classes") {
    pushIfValid(filters, "class", state.chosenClass);
  }

  // Student filter should never include identifiers
  if (state.chosenStudent && state.chosenStudent !== "All Students") {
    filters.push("student:filtered");
  }

  // Other common filters (non-PII)
  if (state.chosenEmotion && state.chosenEmotion !== "all emotions") {
    pushIfValid(filters, "emotion", state.chosenEmotion);
  }
  if (state.helpfulFilter && state.helpfulFilter !== "All") {
    pushIfValid(filters, "helpful", state.helpfulFilter);
  }

  return filters;
};
